export const categoryCodes = [
  'BUSINESS_AREA',
  'INST_SECTOR',
  'LEGAL_FORM',
] as const;

export type CategoryCode = (typeof categoryCodes)[number];
